import { ASC } from './table/constants';
import moment from 'moment';

const alphanumericSort = (sort, prev, next) => {
  // Note: Number('') returns 0
  const truePrev = Number.isNaN(Number(prev)) || prev === '' ? prev.toUpperCase() : Number(prev);
  const trueNext = Number.isNaN(Number(next)) || next === '' ? next.toUpperCase() : Number(next);
  if (sort === ASC) {
    return truePrev > trueNext;
  }
  return truePrev < trueNext;
};

export const alphanumericSortUtils = (arr, key, order = ASC) => {
  if (key === 'starttime') {
    // date sort
    return arr.sort((a, b) => {
      const dateA = moment(a[key], 'YYYY-MM-DD HH:mm:ss.SSS');
      const dateB = moment(b[key], 'YYYY-MM-DD HH:mm:ss.SSS');

      if (order === ASC) {
        return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
      } else {
        return dateA.isBefore(dateB) ? 1 : dateA.isAfter(dateB) ? -1 : 0;
      }
    });
  }

  return arr.sort((a, b) => {
    const regex = /(\d+|\D+)/g;
    const aChunks = (a[key] || '').toString().match(regex);
    const bChunks = (b[key] || '').toString().match(regex);

    for (let i = 0; i < Math.max(aChunks.length, bChunks.length); i++) {
      if (!aChunks[i]) return order === ASC ? -1 : 1;
      if (!bChunks[i]) return order === ASC ? 1 : -1;

      const aChunk = aChunks[i];
      const bChunk = bChunks[i];

      const aIsNumber = !isNaN(aChunk);
      const bIsNumber = !isNaN(bChunk);

      if (aIsNumber && bIsNumber) {
        const aNum = parseInt(aChunk, 10);
        const bNum = parseInt(bChunk, 10);
        if (aNum !== bNum) {
          return order === ASC ? aNum - bNum : bNum - aNum;
        }
      } else if (aIsNumber) {
        return order === ASC ? -1 : 1;
      } else if (bIsNumber) {
        return order === ASC ? 1 : -1;
      } else {
        if (aChunk.toLowerCase() < bChunk.toLowerCase()) return order === ASC ? -1 : 1;
        if (aChunk.toLowerCase() > bChunk.toLowerCase()) return order === ASC ? 1 : -1;
      }
    }
    return 0;
  });
};

export default alphanumericSort;
